export const ORDER_FORM_TYPE_OUTER = 'form_outer';
export const ORDER_FORM_TYPE_INNER = 'form_inner';